import React, {ReactElement} from 'react';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {action, ObservableMap} from "mobx";
import {observer} from "mobx-react";
import MdEntity from "./mdEntity";
import {DATATYPE} from "core/metamodel/mdField";
import {MdCheckbox, MdTextField} from "core/components/fields/fields";
import {DynamicField} from "./metaDomain";
import {IDomainObject} from "../form/formUtils";
import {DomainAncestor} from "../common/domain/DomainAncestor";


interface DynamicFieldsBlockProps  {
  dataObject: DomainAncestor & {fields: DynamicField[]};
  rootObject: DomainAncestor;
  entities: ObservableMap<MdEntity>;
  entity?: MdEntity;
  header?: ReactElement|string;
}



@observer
export class DynamicFieldsBlock extends React.Component<DynamicFieldsBlockProps, undefined> {




  render() {

    let {dataObject, rootObject, entity, entities, header} = this.props;



    return (
          <BlockComp header={header}>
            {
              dataObject.fields.map(dynField => (
                <div className="row">
                  <div className="fx col-xs-4">
                    {dynField.label}
                  </div>
                  <div className="fx col-xs-8">
                    <DynamicFieldComp dynamicField={dynField} entities={entities} entity={entity} rootObject={rootObject} />
                  </div>
                </div>
              ))
            }

          </BlockComp>
    );
  }
}

interface DynamicFieldCompProps {
  dynamicField: DynamicField;
  entities: ObservableMap<MdEntity>;
  entity: MdEntity;
  rootObject: IDomainObject;
}

const inputStyle = {fontSize: 14, marginRight: 20};

@observer
class DynamicFieldComp extends React.Component<DynamicFieldCompProps, undefined> {




  render() {

    let {rootObject, entity, entities, dynamicField} = this.props;

    switch (dynamicField.$mdFieldRef.dataType) {
      case DATATYPE.BOOLEAN:

        return (
          <MdCheckbox name={dynamicField.fieldName} checked={dynamicField.value}
                      onCheck={this.onCheck}/>
        );

      case DATATYPE.STRING:

        return (
          <MdTextField style={inputStyle} value={dynamicField.value} name={dynamicField.fieldName}  onChange={this.onChange} />
        );

      default:
        throw new Error(dynamicField.$mdFieldRef.dataType + " not implemented yet")
    }

  }

  @action onCheck = (evt, checked) => {
    const {dynamicField, rootObject} = this.props;
    console.log('onCheck checked: ' + checked);
    dynamicField.value = checked;
    rootObject.$dirty = true;
  };

  @action onChange = (evt) => {
    const {dynamicField, rootObject} = this.props;
    console.log('onChange value: ' + evt.target.value);
    dynamicField.value = evt.target.value;
    rootObject.$dirty = true;
  };


}




// WEBPACK FOOTER //
// ./src/core/metamodel/dynamicFields.tsx